import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  themeMode: 'light',
  language: 'en',
  sidebarCollapsed: false,
  direction: 'ltr',
  notifications: [],
  breadcrumbs: [],
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.themeMode = state.themeMode === 'light' ? 'dark' : 'light'
    },
    setTheme: (state, action) => {
      state.themeMode = action.payload
    },
    setLanguage: (state, action) => {
      state.language = action.payload
      state.direction = action.payload === 'ar' ? 'rtl' : 'ltr'
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload
    },
    setDirection: (state, action) => {
      state.direction = action.payload
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      })
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      )
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload
    },
    clearNotifications: (state) => {
      state.notifications = []
    },
  },
})

export const {
  toggleTheme,
  setTheme,
  setLanguage,
  toggleSidebar,
  setSidebarCollapsed,
  setDirection,
  addNotification,
  removeNotification,
  setBreadcrumbs,
  clearNotifications,
} = uiSlice.actions

export default uiSlice.reducer

// Selectors
export const selectThemeMode = (state) => state.ui.themeMode
export const selectLanguage = (state) => state.ui.language
export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed
export const selectDirection = (state) => state.ui.direction
export const selectNotifications = (state) => state.ui.notifications
export const selectBreadcrumbs = (state) => state.ui.breadcrumbs
